const DEFAULT_DATA = {
  columns: 4,
  showTabs: false,
  pagination: "infinite",
  collectionId: [],
  databaseFieldId: "",
  contentFilters: [
    "blog-created",
    "blog-updated",
    "page-created",
    "page-updated",
    "comment-posted",
  ],
  maxNumberOfItems: 4,
  borderRadius: 8,
};

export const WORK_ANNIVERSARY_TEMPLATES = [
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    view: "card",
  },
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    view: "list",
  },
];

export const buildTemplate = (view) => ({
  ...DEFAULT_DATA,
  view,
});
